/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { InvitesAcceptOptions, InvitesAcceptResponses } from '../models/InvitesAccept'
import {
  invitesAcceptResponseSchema,
  invitesAcceptErrorSchema,
  invitesAcceptBodySchema,
} from '../schemas/invitesAcceptSchema'

/**
 * @summary Redeem an invitation: creates the account with the password the invitee chooses, grants them the invited
 * role in the organization and logs them straight in. The token is single-use and the invitation is
 * deleted. Consent is taken on the form, so both acceptance rows are written and no terms gate follows.
 * For a company with no free seat the role is reduced — possibly to "None" — but the account is still
 * created and the join still happens: seats gate the role, never the account.
 * Creation ALWAYS logs in, including the seat-degraded "None" grant, so a 200 always carries the access
 * token and the full user object — there is no "created but not logged in" success.
 * {@link /api/v4/invites/accept}
 */
export function invitesAccept<ThrowOnError extends boolean = true>(
  options: Options<InvitesAcceptOptions, ThrowOnError>
): Unwrappable<RequestResult<InvitesAcceptResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/invites/accept',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: invitesAcceptBodySchema,
        response: invitesAcceptResponseSchema,
        error: invitesAcceptErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<InvitesAcceptResponses, ThrowOnError>>
  )
}
